module.exports = __webpack_public_path__ + "static/media/NotoSansThai-Medium.160f6452.ttf";